import React from 'react';
import CRUDDetailPage from '../../../shared/components/crud/CRUDDetailPage';
import { userConfig } from '../config/index';
import { UserService } from '../../../shared/services/userService';

/**
 * UserDetail - URL-based detail page for Users
 * Handles view, edit, and add modes with ID from URL params
 */
export default function UserDetail() {
  return (
    <CRUDDetailPage
      config={userConfig}
      service={UserService}
    />
  );
}
